import { works } from '@/mocks/works';
import WorkCard from '@/components/feature/WorkCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function LatestWorks() {
  const latest = [...works].sort((a, b) => b.year - a.year).slice(0, 8);

  return (
    <section className="w-full bg-background-100/70">
      <div className="container-page py-12 md:py-16">
        <SectionHeading
          eyebrow="Latest Works"
          title="最新作品预览"
          desc="近期公开的影视作品，点击封面查看作品详情与角色介绍。"
          actionTo="/works"
          actionLabel="查看全部作品"
        />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {latest.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}